import { render, staticRenderFns } from "./adUpload.vue?vue&type=template&id=6051cc6a&scoped=true"
import script from "./adUpload.vue?vue&type=script&lang=js"
export * from "./adUpload.vue?vue&type=script&lang=js"
import style0 from "./adUpload.vue?vue&type=style&index=0&id=6051cc6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6051cc6a",
  null
  
)

export default component.exports